import React from "react";

import { FormControl, MenuItem, Select } from "@mui/material";

import RedditCapi from "components/organisms/SDKs/RedditCapi";

/** Reddit OAuth login and advertiser select ("OR" the manual pixel / token fields). */
const RedditCapiForm = ({ reddit, language }) => {
    const { advertisers, partnerInstallId } = reddit;

    return (
        <div className="position-relative overflow-hidden z-1">
            {!advertisers && (
                <RedditCapi
                    label="continue with reddit capi"
                    onLogin={reddit.handleLogin}
                />
            )}
            {advertisers && partnerInstallId && !!advertisers.length && (
                <div className="mb-3">
                    <FormControl style={{ width: "100%" }}>
                        <Select
                            label={
                                language?.destination_modal?.advertisers ??
                                "Advertisers"
                            }
                            value={reddit.selectedAdvertiser}
                            onChange={reddit.handleAdvertiserChange}
                            error={reddit.advertiserSelectError}
                        >
                            {advertisers.map((item) => (
                                <MenuItem key={item?.id} value={item?.id}>
                                    {item?.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
            )}
            {!advertisers && (
                <span className="d-flex justify-content-center mb-3 mt-3">
                    {language?.lead?.or ?? "OR"}
                </span>
            )}
        </div>
    );
};

export default RedditCapiForm;
